import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import TabView from "legacy/TabView"
import ContractLeftTabLayout from "legacy/contract-groups-v2/ContractLeftTabLayout"
import ContractTableV2 from "legacy/contract-groups-v2/ContractTableV2"
import { centsToDollarsRaw, safePercentageDecimal } from "legacy/helpers.es6"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

// Note: $context is loaded globally

class ContractGroupShowV2Controller extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      form: $context.form
        ? {
            ...$context.form,
            rate: {
              ...$context.form.rate,
              amount: centsToDollarsRaw($context.form.rate.amount),
              taxRate: safePercentageDecimal($context.form.rate.taxRate),
            },
            contractType:
              $context.form.monthToMonth === true
                ? "month_to_month"
                : "standard",
            customBillingPeriod: !!(
              $context.quote.billingStartDate || $context.quote.billingEndDate
            ),
            billingStartDate: $context.quote.billingStartDate,
            billingEndDate: $context.quote.billingEndDate,
            depositEnabled: !!$context.quote.depositAmount,
            depositAmount: $context.quote.depositAmount / 100,
            depositTaxAmount: $context.quote.depositTaxAmount * 100,
            attachments: $context.attachments || [],
            allowDirectPayment: $context.quote.allowDirectPayment,
          }
        : {},
      sendContractResponse: {},
    }
    this.updateSendContractFlash = this.updateSendContractFlash.bind(this)
    this.findInitialTab = this.findInitialTab.bind(this)
    this.tableProps = this.tableProps.bind(this)
    this.renderSendContractFlash = this.renderSendContractFlash.bind(this)
    this.renderAddNewContractButton = this.renderAddNewContractButton.bind(this)
    this.archiveModalCopy = this.archiveModalCopy.bind(this)
  }

  updateSendContractFlash(sendContractResponse) {
    this.setState({ sendContractResponse })
  }

  findInitialTab() {
    const id = this.props.selectedContractId
    if (id) {
      if (_.find(this.props.unsentContracts, { encodedId: id })) {
        return "unsent"
      } else if (_.find(this.props.outstandingContracts, { encodedId: id })) {
        return "outstanding"
      } else if (_.find(this.props.completedContracts, { encodedId: id })) {
        return "completed"
      }
    }
    const allItemsCount =
      this.props.unsentContracts.length +
      this.props.outstandingContracts.length +
      this.props.completedContracts.length
    if (allItemsCount === 0) {
      return null
    } else if (this.props.unsentContracts.length) {
      return "unsent"
    } else if (this.props.outstandingContracts.length) {
      return "outstanding"
    } else if (this.props.completedContracts.length) {
      return "completed"
    }
  }

  tableProps(list, actionButtonType = false) {
    return {
      list,
      actionButtonType,
      selectedContractId: this.props.selectedContractId,
      updateSendContractFlash: this.updateSendContractFlash,
      ..._.pick($context, [
        "marinaName",
        "marinaSlug",
        "contactUrl",
        "canUpdate",
        "sendContractUrl",
        "expireContractUrl",
        "editContractUrl",
        "completeInHouseUrl",
        "markContractDeclinedUrl",
        "deleteContractUrl",
        "reservationContractUrl",
        "generatePdfEndpoint",
        "bulkSendContractsUrl",
      ]),
    }
  }

  renderSendContractFlash() {
    if (this.state.sendContractResponse.success === true) {
      return (
        <div className="mb-3 rounded border border-teal-700 bg-teal-100 p-3">
          Contracts are sending! Please reload the page to see the current
          status of contracts. You may need to wait a few minutes before the
          status is updated.
        </div>
      )
    } else if (this.state.sendContractResponse.success === false) {
      return (
        <div className="mb-3 rounded border border-red-700 bg-red-100 p-3">
          {`Contract failed to send. ${this.state.sendContractResponse.response}`}
        </div>
      )
    } else {
      return null
    }
  }

  renderAddNewContractButton() {
    if ($context.newContractUrl) {
      return (
        <a className="btn btn-primary" href={$context.newContractUrl}>
          Add New
        </a>
      )
    } else {
      return (
        <a
          className="btn btn-primary"
          data-toggle="tooltip"
          data-placement="top"
          title={$context.cannotCreateNonMbmContractText}
          disabled
        >
          Add New
        </a>
      )
    }
  }

  archiveModalCopy() {
    return "Archiving the group will invalidate all unsigned contracts. However, completed contracts will remain unaffected. You can access archived groups from the groups tab on the contracts page."
  }

  render() {
    return (
      <div className="container">
        <div className="grid grid-cols-12 gap-3">
          <ContractLeftTabLayout
            form={this.state.form}
            isGroup={true}
            namedRates={$context.namedRates}
          >
            {$context.canUpdate && (
              <div className="mt-5 flex justify-between">
                <div className="btn-group">
                  <LegacyButton
                    type="tertiary"
                    className="dropdown-toggle"
                    dataToggle="dropdown"
                  >
                    Actions <span className="caret ml-1" />
                  </LegacyButton>
                  <ul className="dropdown-menu" style={{ left: "auto" }}>
                    <li>
                      <a
                        className={classNames({
                          "pointer-events-none cursor-not-allowed bg-gray-100 text-gray-500":
                            $context.lockedGroup,
                        })}
                        href={$context.editGroupUrl}
                      >
                        Edit
                      </a>
                    </li>
                    <li>
                      <a
                        className={classNames({
                          "pointer-events-none cursor-not-allowed bg-gray-100 text-gray-500":
                            $context.lockedGroup,
                        })}
                        href={$context.duplicateGroupUrl}
                      >
                        Duplicate
                      </a>
                    </li>
                    <li>
                      <a
                        className="text-red"
                        data-method="post"
                        data-confirm={this.archiveModalCopy()}
                        href={$context.archiveGroupUrl}
                      >
                        Archive
                      </a>
                    </li>
                  </ul>
                </div>
                {this.renderAddNewContractButton()}
              </div>
            )}
          </ContractLeftTabLayout>
          <div className="col-span-12 sm:col-span-7">
            <h2 className="my-4 ml-2 text-base font-semibold">
              {this.props.unsentContracts.length +
                this.props.outstandingContracts.length +
                this.props.completedContracts.length}{" "}
              Total Contracts
            </h2>
            {this.renderSendContractFlash()}
            <TabView
              pushTabToUrl={true}
              initialTab={this.findInitialTab()}
              tabs={{
                unsent: `${this.props.unsentContracts.length} Unsent`,
                outstanding: `${this.props.outstandingContracts.length} Outstanding`,
                completed: `${this.props.completedContracts.length} Completed`,
              }}
            >
              <div>
                {React.createElement(
                  ContractTableV2,
                  this.tableProps(this.props.unsentContracts, "sendAll"),
                  null
                )}
              </div>
              <div>
                {React.createElement(
                  ContractTableV2,
                  this.tableProps(this.props.outstandingContracts, "resendAll"),
                  null
                )}
              </div>
              <div>
                {React.createElement(
                  ContractTableV2,
                  this.tableProps(this.props.completedContracts),
                  null
                )}
              </div>
            </TabView>
          </div>
        </div>
      </div>
    )
  }
}

ContractGroupShowV2Controller.propTypes = {
  unsentContracts: PropTypes.arrayOf(
    PropTypes.shape({
      encodedId: PropTypes.string.isRequired,
      id: PropTypes.string,
      customerName: PropTypes.string,
      boatName: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      amount: PropTypes.number,
    })
  ).isRequired,
  outstandingContracts: PropTypes.arrayOf(
    PropTypes.shape({
      encodedId: PropTypes.string.isRequired,
      id: PropTypes.string,
      customerName: PropTypes.string,
      boatName: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      amount: PropTypes.number,
    })
  ).isRequired,
  completedContracts: PropTypes.arrayOf(
    PropTypes.shape({
      encodedId: PropTypes.string.isRequired,
      id: PropTypes.string,
      customerName: PropTypes.string,
      boatName: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      amount: PropTypes.number,
    })
  ).isRequired,
  selectedContractId: PropTypes.string,
}

export default ContractGroupShowV2Controller
